<template>
  <div class="automation">
    <div style="margin-bottom: 10px">
      <el-button style="float: left" @click="goBack" type="primary"
        ><i class="fas fa-arrow-left"></i> Go Back</el-button
      >
    </div>
    <div style="clear: both"></div>
    <hr style="margin-top: 10px" />
    <el-table
      :data="data"
      style="width: 100%"
      :default-sort="{ prop: 'created_at', order: 'ascending' }"
      v-loading="loading"
    >
      <!-- <el-table-column prop="when" label="Actions" sortable>
        <template slot-scope="scope">
          <div :key="action.id" v-for="action in scope.row.actions">
            <small>{{ child }}</small>
          </div>
        </template>
      </el-table-column> -->
      <!-- <el-table-column prop="parent" label="Parent" sortable></el-table-column> -->
      <el-table-column prop="id" label="Id" sortable></el-table-column>
      <el-table-column
        prop="automation_id"
        label="automation_id"
        sortable
      ></el-table-column>
      <el-table-column
        prop="user_id"
        label="user_id"
        sortable
      ></el-table-column>
      <el-table-column
        prop="school_id"
        label="school_id"
        sortable
      ></el-table-column>
      <el-table-column
        prop="event_trigger"
        label="event_trigger"
        sortable
      ></el-table-column>
      <el-table-column
        prop="created_at"
        label="Created"
        sortable
      ></el-table-column>
    </el-table>
  </div>
</template>
<script>
import CreatePost from "@/views/CreatePost.vue";
import ApiService from "@/services/ApiService";
export default {
  name: "AutomationsDetaledLogs",
  data() {
    return {
      page: 0,
      data: [],
      loading: false,
    };
  },
  methods: {
    goBack() {
      this.$router.push("/members/automations");
    },
    goto(path) {
      path = "actions/" + path;
      this.$router.push(path);
    },
    loadNextPage() {
      this.page = this.page + 1;
      this.getDetailedLogs();
    },
    getDetailedLogs() {
      ApiService.automationsApi
        .getDetailedLogs(this.$route.params.automation_id, this.page)
        .then((resp) => {
          this.data = resp.data;
        });
    },
  },
  mounted() {
    this.getDetailedLogs();
  },
};
</script>
